import { createSlice } from "@reduxjs/toolkit";
import { clearBusinessAuthInfo, storeBusinessAuthInfo } from "../utils/localstorage";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    isProfileSet: false,
    isEmailVerified: false,
    accessToken: null,
    uuid: null,
    email: null,
  },
  reducers: {
    loginSuccess: (state, action) => {
      let payload = action.payload;

      state.isAuthenticated = true;
      state.accessToken = payload.accessToken;
      state.email = payload.email;
      state.uuid = payload.uuid;
      state.isProfileSet = payload.isProfileSet;

      storeBusinessAuthInfo(state);
    },

    loginFailed: (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.email = null;
      state.uuid = null;
    },

    registerSuccess: (state, action) => {
      let payload = action.payload;

      state.isAuthenticated = true;
      state.accessToken = payload.accessToken;
      state.email = payload.email;
      state.uuid = payload.uuid;
      state.isProfileSet = payload.isProfileSet;

      storeBusinessAuthInfo(state);
    },

    registerFailed: (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.email = null;
      state.uuid = null;
    },
    updateIsProfileSet: (state) => {
      state.isProfileSet = true;
      storeBusinessAuthInfo(state);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.email = null;
      state.uuid = null;

      clearBusinessAuthInfo()
    },
  },
});

export const {
  logout,
  loginSuccess,
  loginFailed,
  registerFailed,
  registerSuccess,
  updateIsProfileSet,
} = authSlice.actions;

export default authSlice.reducer;
